"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutElement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LayoutElement = ({ children, width, maxWidth, fullWidth }) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: { ...(width ? { width } : undefined), ...(maxWidth ? { maxWidth } : undefined) }, className: `${fullWidth ? 'w-100 flex-grow-1' : ''}`, children: children }));
};
exports.LayoutElement = LayoutElement;
